import { RotateCcw } from 'lucide-react';
import { Button, Checkbox } from '@/components/ui';
import { getSelectOptions } from '@/functions';
import { useQueryParams } from '@/hooks';
import { useCallback } from 'react';

const TransactionsFiltersSidebar = () => {
    const { updateSearchParams, urlSearchParams } = useQueryParams(['type', 'category']);

    const handleFilterChange = useCallback((key: string, value: string, checked: boolean) => {
        updateSearchParams(l => {
            if (checked) {
                l.append(key, value);
            } else {
                l.delete(key, value);
            }
            l.set('page', '1');
            return l;
        });
    }, [updateSearchParams]);

    const handleReset = () => {
        updateSearchParams(l => {
            l.delete('type');
            l.delete('category');
            l.set('page', '1');
            return l;
        });
    };

    const typeOptions = getSelectOptions('TransactionTypeEnum').filter(o => o.value);
    const categoryOptions = getSelectOptions('TransactionCategoryEnum').filter(o => o.value);

    const activeTypes = urlSearchParams.getAll('type');
    const activeCategories = urlSearchParams.getAll('category');

    return (
        <div className="space-y-6 max-h-[70vh] overflow-y-auto px-1">
            <div className="flex items-center justify-end">
                <Button variant="ghost" size="sm" onClick={handleReset} className="h-8 text-xs text-muted-foreground hover:text-foreground">
                    <RotateCcw size={14} className="mr-1" />
                    Reset
                </Button>
            </div>

            {/* Type */}
            <div className="space-y-3">
                <h4 className="text-sm font-medium">Type</h4>
                <div className="grid grid-cols-1 gap-2">
                    {typeOptions.map(option => (
                        <div key={option.value} className="flex items-center space-x-2">
                            <Checkbox
                                id={`type-${option.value}`}
                                checked={activeTypes.includes(option.value as string)}
                                onCheckedChange={(checked) =>
                                    handleFilterChange('type', option.value as string, checked as boolean)
                                }
                            />
                            <label htmlFor={`type-${option.value}`} className="text-sm cursor-pointer truncate">
                                {option.title}
                            </label>
                        </div>
                    ))}
                </div>
            </div>

            {/* Categories */}
            <div className="space-y-3">
                <h4 className="text-sm font-medium">Catégories</h4>
                <div className="grid grid-cols-1 gap-2">
                    {categoryOptions.map(option => (
                        <div key={option.value} className="flex items-center space-x-2">
                            <Checkbox
                                id={`cat-${option.value}`}
                                checked={activeCategories.includes(option.value as string)}
                                onCheckedChange={(checked) =>
                                    handleFilterChange('category', option.value as string, checked as boolean)
                                }
                            />
                            <label htmlFor={`cat-${option.value}`} className="text-sm cursor-pointer truncate">
                                {option.title}
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TransactionsFiltersSidebar;
